<template>
  <div>
    <!-- <div class="field-row">
        <input type="text" v-model="title" name="" id="" placeholder="Category name" />
    </div>
    <div class="field-row">
        <Textarea v-model="description" placeholder="description"></Textarea>
    </div>
    <div class="field-row">
        <button @click.prevent="savedata">Save</button>
    </div> -->
    <a-modal v-model="visible" title="Edit Category Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Edit Category</a-button>
      </template>
      <a-form class="mb-4" :form="form">
        <a-form-item label="Category Name">
            <a-input
                placeholder="Category name"
                v-decorator="['name', {rules: [{ required: true, message: 'Please input category name!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
            />
        </a-form-item>
<!--        <a-form-item label="Category Code">
          <a-input
            placeholder="Category code"
            v-decorator="['code', {rules: [{ required: true, message: 'Please input category code!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
          />
        </a-form-item>-->
        <a-form-item label="Parent Category">
          <a-select placeholder="Select parent category" v-decorator="['parent_category_id', { rules: [{ required: false, message: 'Please select a category!'}], initialValue: undefined}]">
            <a-select-option :value="undefined">
              Select parent category
            </a-select-option>
            <a-select-option v-for="(cat, index) in parentCategories" :key="index" :value="cat.id">{{cat.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 100, message: 'Must not exceed 100 characters!'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'EditCategory',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      parentCategories: [],
    }
  },
  mounted: function () {
    this.$eventBus.$on('openEditForm', this.showForm)
  },
  methods: {
    showForm: function(record) {
      this.visible = true
      this.getParentCategories()
      // console.log('passed record', record)
      this.oldrecord = record
      setTimeout(() => {
        this.form.setFieldsValue({
          'name': record.name,
          'code': record.code,
          'parent_category_id': record.parent_category_id,
          'description': record.description,
        })
      }, 50)
    },
    getParentCategories: function() {
      this.$http.get('/api/inventory/category')
        .then(({ data }) => {
          this.parentCategories = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log('old data', this.oldrecord)
        console.log('formdata', values)
        if (!err) {
          this.$http
            .patch(`/api/inventory/category/${this.oldrecord.id}`, {
              name: values.name,
              parent_category_id: values.parent_category_id,
              description: values.description,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.$notification['success']({
                  message: 'Successfully edited',
                  description: 'Category details edited successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>

<style>

</style>
